// // // SessionContext.tsx - sessionStorage로 수정된 버전
// // import { createContext, useCallback, useEffect, useMemo, useReducer } from 'react';
// // import axios from 'axios';

// // import { useStores } from '../models';
// // import { IAuthUserSnapshot } from '../models/auth-user/AuthUser';

// // import { ActionMapType, AuthStateType, AuthUserType, SessionContextType } from './types';

// // enum Types {
// //   INITIAL = 'INITIAL',
// //   LOGIN = 'LOGIN',
// //   REGISTER = 'REGISTER',
// //   LOGOUT = 'LOGOUT',
// // }

// // type Payload = {
// //   [Types.INITIAL]: {
// //     isAuthenticated: boolean;
// //     user: AuthUserType;
// //   };
// //   [Types.LOGIN]: {
// //     user: AuthUserType;
// //   };
// //   [Types.REGISTER]: {
// //     user: AuthUserType;
// //   };
// //   [Types.LOGOUT]: undefined;
// // };

// // type ActionsType = ActionMapType<Payload>[keyof ActionMapType<Payload>];

// // // ----------------------------------------------------------------------

// // const initialState: AuthStateType = {
// //   isInitialized: false,
// //   isAuthenticated: false,
// //   user: null,
// // };

// // const reducer = (state: AuthStateType, action: ActionsType) => {
// //   if (action.type === Types.INITIAL) {
// //     return {
// //       isInitialized: true,
// //       isAuthenticated: action.payload.isAuthenticated,
// //       user: action.payload.user,
// //     };
// //   }
// //   if (action.type === Types.LOGIN) {
// //     return {
// //       ...state,
// //       isAuthenticated: true,
// //       user: action.payload.user,
// //     };
// //   }
// //   if (action.type === Types.REGISTER) {
// //     return {
// //       ...state,
// //       isAuthenticated: true,
// //       user: action.payload.user,
// //     };
// //   }
// //   if (action.type === Types.LOGOUT) {
// //     return {
// //       ...state,
// //       isAuthenticated: false,
// //       user: null,
// //     };
// //   }
// //   return state;
// // };

// // export const AuthContext = createContext<SessionContextType | null>(null);

// // type AuthProviderProps = {
// //   children: React.ReactNode;
// // };

// // export function AuthProvider({ children }: AuthProviderProps) {
// //   const { authStore } = useStores();
// //   const [state, dispatch] = useReducer(reducer, initialState);

// //   const initialize = useCallback(async () => {
// //     try {
// //       // 🔄 localStorage → sessionStorage로 변경
// //       // if (!window.localStorage.getItem('remember')) {
// //       // }
// //       // if (window.localStorage.getItem('remember') === 'true') {
// //       //   const id = window.localStorage.getItem('id');
// //       //   const pw = window.localStorage.getItem('pw');
// //       //   if (!id) {
// //       //     return;
// //       //   }
// //       //   if (!pw) {
// //       //     return;
// //       //   }
// //       // }

// //       // ✅ localStorage → sessionStorage로 변경
// //       if (!window.sessionStorage.getItem('loginUser')) {
// //         dispatch({
// //           type: Types.INITIAL,
// //           payload: {
// //             isAuthenticated: false,
// //             user: null,
// //           },
// //         });
// //         return;
// //       }

// //       // ✅ localStorage → sessionStorage로 변경
// //       const myInfoStr = sessionStorage.getItem('loginUser');
// //       const myInfo = myInfoStr ? JSON.parse(myInfoStr) : null;

// //       if (myInfo) {
// //         // if (myInfo && myInfo.resultCode === 'S' && myInfo.data && myInfo.data.oprtrSid > 0) {
// //         // if (myInfo.data) {
// //         //   if (myInfo.data.menuList) {
// //         //     const menuList = myInfo.data.menuList;
// //         //     menuList.map((v) => {
// //         //       v.regDt = moment(v.regDt).format('YYYY-MM-DD hh:mm:ss');
// //         //       v.updDt = moment(v.updDt).format('YYYY-MM-DD hh:mm:ss');
// //         //     });
// //         //   }
// //         // }
// //         const user: IAuthUserSnapshot = {
// //           userSid: myInfo.userSid,
// //           userId: myInfo.userId,
// //           userNm: myInfo.userNm,
// //           // menuList: myInfo.data.menuList,
// //         };
// //         // authStore.goodLoginStatus(user);

// //         dispatch({
// //           type: Types.INITIAL,
// //           payload: {
// //             isAuthenticated: true,
// //             user,
// //           },
// //         });
// //       } else {
// //         // authStore.badLoginStatus();

// //         // ✅ localStorage → sessionStorage로 변경
// //         window.sessionStorage.removeItem('loginUser');
// //         dispatch({
// //           type: Types.INITIAL,
// //           payload: {
// //             isAuthenticated: false,
// //             user: null,
// //           },
// //         });
// //       }
// //     } catch (error) {
// //       console.error(error);

// //       // ✅ localStorage → sessionStorage로 변경
// //       window.sessionStorage.removeItem('loginUser');
// //       dispatch({
// //         type: Types.INITIAL,
// //         payload: {
// //           isAuthenticated: false,
// //           user: null,
// //         },
// //       });
// //     }
// //   }, []);

// //   useEffect(() => {
// //     initialize();
// //   }, [initialize]);

// //   const { REACT_APP_API_URL } = process.env;

// //   // LOGIN
// //   const login = useCallback(async (email?: string, password?: string) => {
// //     const response = await axios.post(REACT_APP_API_URL + '/loginProcess', {
// //       userId: email,
// //       userPw: password,
// //     });
// //     return response;
// //   }, []);

// //   // LOGOUT
// //   const logout = () => {
// //     // ✅ sessionStorage도 클리어 추가
// //     window.sessionStorage.removeItem('loginUser');
// //     authStore.logout();

// //     // 상태도 업데이트
// //     dispatch({
// //       type: Types.LOGOUT,
// //       // payload: undefined,
// //     });
// //   };

// //   const memoizedValue = useMemo(
// //     () => ({
// //       // isInitialized: authStore.authStatus.isInitialized || state.isInitialized,
// //       // isAuthenticated: authStore.authStatus.isAuthenticated || state.isAuthenticated,
// //       user: authStore.getLoginUserStorageData(),
// //       isInitialized: state.isInitialized,
// //       isAuthenticated: state.isAuthenticated,
// //       // user: state.user,
// //       method: 'session',
// //       login,
// //       logout: logout,
// //     }),
// //     [
// //       authStore.authStatus?.isAuthenticated,
// //       authStore.authStatus?.isInitialized,
// //       authStore.getLoginUserStorageData(),
// //       state.isAuthenticated,
// //       state.isInitialized,
// //       state.user,
// //       logout,
// //     ],
// //   );

// //   return <AuthContext.Provider value={memoizedValue}>{children}</AuthContext.Provider>;
// // }

import { createContext, ReactNode, useEffect, useMemo } from 'react';
import { observer } from 'mobx-react-lite';

import { useStores } from '../models';

export interface SessionContextType {
  user: any;
  isInitialized: boolean;
  isAuthenticated: boolean;
  logout: () => void;
}

export const AuthContext = createContext<SessionContextType | null>(null);

interface AuthProviderProps {
  children: ReactNode;
}

// export function AuthProvider({ children }: AuthProviderProps) {
//   const { authStore } = useStores();

//   // 앱 시작시 한번만 초기화
//   useEffect(() => {
//     authStore.initialize();
//   }, [authStore]);

//   // const memoizedValue = useMemo(
//   //   () => ({
//   //     user: authStore.getLoginUserStorageData(),
//   //     isInitialized: authStore.authStatus.isInitialized,
//   //     isAuthenticated: authStore.authStatus.isAuthenticated,
//   //     logout: authStore.logout,
//   //   }),
//   //   [
//   //     authStore.authStatus.isInitialized,
//   //     authStore.authStatus.isAuthenticated,
//   //     authStore.getLoginUserStorageData(),
//   //     authStore.logout,
//   //   ],
//   // );
//   const memoizedValue = useMemo(() => {
//     const user = authStore.getLoginUserStorageData();
//     // ✅ 실제 user 존재 여부로 인증 상태 결정
//     const isAuthenticated = !!user;

//     return {
//       user,
//       isInitialized: true,
//       // isInitialized: authStore.authStatus.isInitialized,
//       isAuthenticated, // ← AuthStore 상태 무시하고 user 존재 여부로 결정
//       logout: authStore.logout,
//     };
//   }, [authStore.authStatus.isInitialized, authStore.getLoginUserStorageData(), authStore.logout]);

//   return <AuthContext.Provider value={memoizedValue}>{children}</AuthContext.Provider>;
// }

export const AuthProvider = observer(({ children }: AuthProviderProps) => {
  const { authStore } = useStores();

  useEffect(() => {
    authStore.initialize();
  }, [authStore]);

  const memoizedValue = useMemo(
    () => ({
      // AuthStore 상태를 신뢰하고 직접 사용
      user: authStore.getLoginUserStorageData(),
      isInitialized: authStore.authStatus.isInitialized,
      isAuthenticated: authStore.authStatus.isAuthenticated, // sessionStorage 대신 MobX 상태 사용
      logout: authStore.logout,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      authStore.authStatus.isInitialized,
      authStore.authStatus.isAuthenticated, // MobX observable 의존성
      // authStore.getLoginUserStorageData,
      // authStore.logout,
    ],
  );

  return <AuthContext.Provider value={memoizedValue}>{children}</AuthContext.Provider>;
});
